<template>
    <v-layout row wrap>
        <loading-component :value="loading"/>

        <v-flex xs12 class="text-xs-center" v-if="estimated">
            Estimted Time is {{estimated}}
        </v-flex>

        <v-flex xs12>
            <v-text-field v-model="datetime" type="datetime-local" label="Datetime"/>
        </v-flex>

        <v-flex xs12>
            <v-btn @click="search">
                Check Response
            </v-btn>
        </v-flex>
        <v-flex xs12>
            <div id='map'/>
        </v-flex>
    </v-layout>
</template>

<script>
    import Mapbox from "mapbox-gl";
    import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
    import moment from "moment";
    import LoadingComponent from "@/components/LoadingComponent";


    export default {
        name: "Test",
        components: {LoadingComponent},
        title: "Test",
        data() {
            return {
                map: null,
                loading: false,
                marker: null,
                datetime: moment().format("YYYY-MM-DDTHH:mm"),
                estimated: null
            }
        },
        mounted() {
            Mapbox.accessToken = this.api.mapBox.accessToken;
            this.marker = new Mapbox.Marker({draggable: true});
            this.marker.setLngLat(this.api.mapBox.center);

            this.map = new Mapbox.Map(Object.assign({container: 'map',},
                this.api.mapBox,
                {center: this.marker.getLngLat()}
            ));
            this.map.addControl(new Mapbox.FullscreenControl());

            this.marker.addTo(this.map);

        },
        methods: {
            search() {
                this.loading = true;

                const params = new URLSearchParams();

                params.append('lat', this.marker.getLngLat().lat);
                params.append('lon', this.marker.getLngLat().lng);
                params.append('date_time', moment(this.datetime).format("YYYY-MM-DD HH:mm:ss"));
                this.axios.get('http://62.138.7.75:5356/monaco_eta_location', {params})
                    .then(
                        ({data}) => {
                            const floor = Math.floor(data);
                            this.estimated = floor + ":" + Number((data - floor) * 60).toFixed(0);
                        }
                    )
                    .finally(
                        () => this.loading = false
                    )
            }
        }
    }
</script>

<style scoped>
    #map {
        width: 100%;
        height: 720px;
    }
</style>